require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/916/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 290
// module chunks = 0